import { Global, css } from '@emotion/react';
import { theme } from '../../theme';

export const CookieConsentStyle = () => {
  return (
    <Global
      styles={css`
        :root {
          /* Base styling */
          --cc-font-family: ${theme.typography.body?.medium?.regular?.family};
          --cc-bg: ${theme.colors.backgroundCover.default};
          --cc-primary-color: ${theme.colors.text.primary};
          --cc-secondary-color: ${theme.colors.text.secondary};
          --cc-link-color: ${theme.colors.actionPrimary.default};

          /* Button styling */
          --cc-btn-border-radius: 2rem;

          /* Primary button */
          --cc-btn-primary-bg: ${theme.colors.actionPrimary.default};
          --cc-btn-primary-color: ${theme.colors.textInverted.primary};
          --cc-btn-primary-border-color: ${theme.colors.actionPrimary.default};
          --cc-btn-primary-hover-bg: ${theme.colors.actionPrimary.hover};
          --cc-btn-primary-hover-color: ${theme.colors.textInverted.primary};
          --cc-btn-primary-hover-border-color: ${theme.colors.actionPrimary.hover};

          /* Secondary button */
          --cc-btn-secondary-bg: ${theme.colors.backgroundCover.default};
          --cc-btn-secondary-color: ${theme.colors.actionPrimary.default};
          --cc-btn-secondary-border-color: ${theme.colors.actionPrimary.default};
          --cc-btn-secondary-hover-bg: ${theme.colors.textInverted.primary};
          --cc-btn-secondary-hover-color: ${theme.colors.actionSecondary.hover};
          --cc-btn-secondary-hover-border-color: ${theme.colors.actionSecondary.hover};

          /* Toggle styling */
          --cc-pm-toggle-border-radius: 1rem;
          --cc-toggle-on-bg: ${theme.colors.actionPrimary.default};
          --cc-toggle-off-bg: ${theme.colors.actionPrimary.disabled};
          --cc-toggle-on-knob-bg: ${theme.colors.backgroundCover.default};
          --cc-toggle-off-knob-bg: ${theme.colors.backgroundCover.default};
          --cc-toggle-readonly-bg: ${theme.colors.actionSecondary.default};
          --cc-toggle-readonly-knob-bg: ${theme.colors.backgroundCover.default};
          --cc-toggle-readonly-knob-icon-color: ${theme.colors.actionInvertedPrimary.default};

          /* Cookie category blocks */
          --cc-cookie-category-block-bg: ${theme.colors.backgroundBasic.default};
          --cc-cookie-category-block-border: ${theme.colors.borderMain.default};
          --cc-cookie-category-block-hover-bg: ${theme.colors.backgroundBasic.hover};
          --cc-cookie-category-block-hover-border: ${theme.colors.borderMain.hover};
          --cc-cookie-category-expanded-block-bg: ${theme.colors.backgroundBasic.default};
          --cc-cookie-category-expanded-block-hover-bg: ${theme.colors.backgroundBasic.hover};

          /* Separators and layout */
          --cc-separator-border-color: ${theme.colors.borderSeparator.default};
          --cc-overlay-bg: rgba(0, 0, 0, 0.5);
          --cc-modal-margin: 1rem;
          --cc-modal-border-radius: 0.5rem;
          --cc-modal-transition-duration: 0.3s;

          /* Footer */
          --cc-footer-bg: ${theme.colors.backgroundBasic.default};
          --cc-footer-color: ${theme.colors.text.secondary};
          --cc-footer-border-color: ${theme.colors.borderMain.default};
        }
      `}
    />
  );
};
